angular.module('elogbooksServices').service('confirmationModal', ['$uibModal', function ($uibModal) {
    return {
        open: function (config, size) {
            size = size || 'md';
            return $uibModal.open({
                templateUrl: '/modules/common/modals/confirmation/confirmation.html',
                controller: 'ConfirmationModalController',
                controllerAs: 'vm',
                size: size,
                resolve: {
                    config: function () {
                        var defaultConfig = {
                            titleMessage: 'ARE_YOU_SURE_HEADER',
                            bodyMessage: 'ARE_YOU_SURE',
                            primaryText: 'YES',
                            primaryClass: 'btn-danger',
                            secondaryText: 'NO',
                            secondaryClass: 'btn-default'
                        };

                        return angular.extend({}, defaultConfig, config);
                    }
                }
            });
        }
    };
}]);
